const T_PREFIX = "footer";

export const mainLinks = {
  home: `${T_PREFIX}.main-links.home`,
  opportunities: `${T_PREFIX}.main-links.opportunities`,
  aboutUs: `${T_PREFIX}.main-links.about-us`,
  contactUs: `${T_PREFIX}.main-links.contact-us`,
  blog: `${T_PREFIX}.main-links.blog`,
};

export const infoLinks = {
  termsDisclaimer: `${T_PREFIX}.info-links.terms-disclaimer`,
  privacyPolicy: `${T_PREFIX}.info-links.privacy-policy`,
  cookiePolicy: `${T_PREFIX}.info-links.cookie-policy`,
};
